import { Notification as customNotification } from '../../components/ui/custom-notification';
import get from 'lodash/get';
import axiosConfig from './axiosConfig';
import axios from 'axios';
import { handleExcelDownload } from '../../utils/excelUtils';


export const AddSpecification = async (specificationData,isEdit) => {

    try {
      let res;

        const url = `/pipeDocuments/createUpdatePipeDocument`;
      
        res = await axiosConfig.post(url, specificationData);
      
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        // customNotification.success(
        //   'Specification Saved Successfully',
        //   'The specification has been saved successfully.'
        // );
        return res.data;
      }
      if (res.status === 502) {
        customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
        return null;
      }
      return null;
    } catch (error) {
      customNotification.error('Failed to add specification', error.error);
      return null;
    }
  }


  export const GetAllSpecification = async (project_id) => {
    try {
    
     const   url = `/pipeDetails/getAllPipeDetails?project_id=${project_id}`;
  
      const res = await axiosConfig.get(url);
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      } if (res.status === 200) {
        const data = get(res, ['data', 'data'], {});
        return data || {};
      }
      return [];
    } catch (error) {
      customNotification.error('Failed to fetch specification', error.data);
      return [];
    }
  };


  // Function to upload files to S3
  export const getPreSignedUrlToUpload = async (fileList, payload,version =1) => {
    try {
        const uploadedFiles = [];

        if (fileList && fileList.length > 0) {
            // Create file objects for all files
            const fileObjs = fileList.map(file => ({
                fileName: file.name.replace(/\(\d+\)/g, "").trim(), // Remove (1), (2), etc.
                contentType: file.type,
                pipeId: payload.pipeId,
                projectId: payload.projectId,
                projectTypeId: payload.projectTypeId,
                type: payload.type,
                fileSize: file.size, // Use actual file size
               // version: version || 1
            }));
            

            // Get signed URLs for all files at once
            const response = await axiosConfig.post(`pipeDocuments/getPreSignedUrlToUpload`, fileObjs);
            
            if (response.status === 200) {
                const presignedData = response.data.data;
                
                // Process each presigned URL
                for (const data of presignedData) {
                    const file = fileList.find(f => f.name.replace(/\(\d+\)/g, "").trim() === data.fileName);
                    
                    if (file) {
                    
                        
                        // Validate presigned URL data
                        if (!data.presignedUrl) {
                            customNotification.error('Upload Failed', 'Failed to get upload URL from server.');
                            continue; // Skip this file and continue with next
                        }
                        
                        try {
                            // Log the presigned URL (remove sensitive parts for security)
                            const urlParts = data.presignedUrl.split('?');
                           
                            
                            // Small delay to ensure URL is ready (optional)
                            await new Promise(resolve => setTimeout(resolve, 100));
                            
                            // Upload file to S3
                            const uploadResponse = await axios.put(data.presignedUrl, file, {
                                headers: {
                                    "Content-Type": file.type || "application/octet-stream",
                                   // "Content-Disposition": `attachment; filename="${file.name}"`
                                },
                            });

                            if (uploadResponse.status === 200) {
                                uploadedFiles.push({ s3Key: data.s3Key, fileName: data.fileName });
                            
                            } else {
                                customNotification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
                            }
                        } catch (error) {
                            // Add more detailed error logging
                            if (error.response) {
                            }
                            // Show user-friendly error
                            customNotification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
                        }
                    } else {
                        customNotification.error('File Upload Failed', `File ${data.fileName} not found.`);
                    }
                }
            } else {
                customNotification.error('Upload Failed', 'Failed to get upload URLs from server.');
            }
            
        
        }
        return uploadedFiles;
    } catch (error) {
        return []; // Return empty array on error
    }
};
export const CheckPipeDocumentUsingProduction = async (docIds) => {
  try {
    let dataObjet = {
      docIds: docIds
    }

    const res = await axiosConfig.post(`/pipeDocuments/checkDocumentsUsedInProduction`, dataObjet);

    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      return res.data.data;
    }
    return null;
  } catch (error) {
    customNotification.error('Failed to check documents', error.response?.data?.message || error.message || 'An error occurred');
    return null;
  }
}


export const deleteSpecificationDoc = async (docIds,specification,typeName) => {
    try {
      let dataObjet = {
        docIds: docIds
      }
  
      const res = await axiosConfig.post(`/pipeDocuments/deletePipeDocumentsByDocId`, dataObjet);
  
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        customNotification.success('Specifications deleted successfully', `${typeName} document have been deleted`);
        return res.data;
      }
      return null;
    } catch (error) {
      customNotification.error( 'Failed to delete documents', error.data);
      return null;
    }
  }
  export const deleteSpecifications = async (pipeIds,typeName) => {
    try {
      
      // Handle both single pipeId and array of pipeIds
      const pipeIdsArray = Array.isArray(pipeIds) ? pipeIds : [pipeIds];
      
      // Delete each pipe's documents
      const deletePromises = pipeIdsArray.map(async (pipeId) => {
        const res = await axiosConfig.delete(`/pipeDocuments/deletePipeDocumentByPipeId/${pipeId}`);
        
        if (res.status === 403) {
          customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
          return null;
        }
        if (res.status === 200) {
         // customNotification.success( 'Specifications deleted successfully', `${pipeId} pipe related documents have been deleted`);
          return pipeId;
        }
        return null;
      });
      
      const results = await Promise.all(deletePromises);
      const successfulDeletes = results.filter(result => result !== null);
      
      if (successfulDeletes.length > 0) {
        customNotification.success( 'Specifications deleted successfully', `${typeName}  related documents have been deleted`);
        return successfulDeletes;
      } else {
        customNotification.error( 'Failed to delete documents', 'No documents were deleted');
        return null;
      }
    } catch (error) {
      customNotification.error( 'Failed to delete documents', error.data || error.message);
      return null;
    }
  }

  export const getSpecificationsTemplate = async (projectId,projectTypeId,type) => {
    try {
    
      
      // Create a custom axios instance for this request to handle blob response
      
      const res = await axiosConfig.post(`/utils/generateExcelTemplate`,{
        fileName: type,
        fileType: "excel",
        projectId: projectId,
        projectTypeId: projectTypeId
      });
      
      
        
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        // Use the comprehensive download handler
        const result = await handleExcelDownload(res.data?.data?.downloadUrl, `Specifications_template.xlsx`);
        
        if (result.success) {
          customNotification.success('Specifications template downloaded successfully', `Specifications template has been downloaded successfully`);
        } else {
          customNotification.error('Download failed', result.error);
        }
        
        return res.data;
      }
      return null;
      
    } catch (error) {
      customNotification.error('Failed to download template', error.data || error.message);
      return null;
    }
  }


  export const UpdateDocumentApprovalStatus = async (payload) => {
    try {
     
      const res = await axiosConfig.put(`/pipeDocuments/updateApprovalStatus`, payload);
  
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        customNotification.success('Document approval status updated successfully', `Document approval status has been updated successfully`);
        return res.data;
      }
      return null;
    } catch (error) {
      customNotification.error( 'Failed to delete documents', error.data);
      return null;
    }
  }

  export const UpdateRegistryApprovalStatus = async (payload) => {
    try {
      const res = await axiosConfig.put(`/registry/updateApprovalStatus`, payload);
  
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        customNotification.success('Document approval status updated successfully', `Document approval status has been updated successfully`);
        return res.data;
      }
      return null;
    } catch (error) {
      customNotification.error('Failed to update approval status', error.data);
      return null;
    }
  }

  export const UpdateTeamMemberApprovalStatus = async (payload) => {
    try {
      const res = await axiosConfig.put(`/teamMembers/updateApprovalStatus`, payload);
  
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        customNotification.success('Document approval status updated successfully', `Document approval status has been updated successfully`);
        return res.data;
      }
      return null;
    } catch (error) {
      customNotification.error('Failed to update approval status', error.data);
      return null;
    }
  }

  /**
   * Generate Registry Book - combines multiple report types into a single PDF
   * @param {Object} payload - { projectId, reportTypes?: string[], emailAddress?: string[] }
   * @returns {Object} - { downloadUrl, fileName, docId, includedReports, excludedReports, ... }
   */
  export const GenerateRegistryBook = async (payload) => {
    try {
      const res = await axiosConfig.post(`/download-proxy/reports/registry-book`, payload);
  
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to generate registry book.');
        return null;
      }
      if (res.status === 200 || res.status === 201) {
        customNotification.success('Registry Book Generated', 'Registry book has been generated successfully.');
        return res.data;
      }
      return null;
    } catch (error) {
      customNotification.error('Failed to generate registry book', error?.response?.data?.message || error?.message || 'Unknown error');
      return null;
    }
  }